import axios from 'axios';
import multiViewsProjectsModel from '../../models/multiViewsProjects';
import routerHelper from '../../helpers/router';
import { checkPricingAccess } from '../../helpers/pricingHelper';
import chunkHelper from "./chunkHelper";

const _ = require('lodash');

const _default = {
  columns: {
    project_name: {
      hidden: false,
    },
    start_date: {
      hidden: false,
    },
    end_date: {
      hidden: true,
    },
    duration: {
      hidden: true,
    },
    estimation: {
      hidden: true,
    },
    time_tracking: {
      hidden: false,
    },
    progress: {
      hidden: true,
    },
    total_price: {
      hidden: true,
    },
    assigned: {
      hidden: false,
    },
    creator: {
      hidden: true,
    },
    status: {
      hidden: false,
    },
    priority: {
      hidden: true,
    },
    create_date: {
      hidden: true,
    },
  },
  settings: {
    viewSettings: {
      skins: 4,
      completedTask: [], // 'crossOutTasks', 'discolorationTasks'
    },
    overdue: undefined,
  },
};

const listViewStore = {
  namespaced: true,
  state: {
    url: 'api/list',
    configs: null,
    loading: true,
    currentConfig: null,
    totalTasks: [],
    filtredTasks: [],
    unsavedChangesInConfig: false,
    selectedTasks: [],
  },

  getters: {
    totalTasks: state => state.totalTasks,
    filtredTasks: state => state.filtredTasks,
    url: state => state.url,
    configs: state => state.configs,
    loading: state => state.loading,
    currentConfig: state => state.currentConfig,
    unsavedChangesInConfig: state => state.unsavedChangesInConfig,
    selectedTasks: state => state.selectedTasks,
  },

  mutations: {
    setselectedTasks(state, vals) {
      state.selectedTasks = vals;
    },

    setTasks(state, val) {
      state.totalTasks = val;
    },

    setFiltredTasks(state, val) {
      state.filtredTasks.splice(0);

      if (Array.isArray(val)) {
        // state.filtredTasks.push(...val);
        chunkHelper.chunkMutation(state.filtredTasks, val);
      }

      this.commit('headerView/setListTasksCount', val?.length || 0);
    },

    pushToFiltredTasks(state, val) {
      const tasks = Array.isArray(val) ? val : [val];

      const existTasksId = state.filtredTasks.map(i => i.id);
      const taskToAdd = tasks.filter(i => !existTasksId.includes(i.id));

      if (!taskToAdd.length) { return; }

      chunkHelper.chunkMutation(state.filtredTasks, tasks);

      // state.filtredTasks.push(...tasks);
    },

    setConfigs(state, val) {
      state.configs = val || [];
    },

    setLoading(state, val) {
      state.loading = val;
    },

    setCurrentConfig(state, value) {
      if (!value) {
        state.currentConfig = null;

        return;
      }

      const config = _.clone(value);

      config.columns = typeof config.columns === 'string'
        ? JSON.parse(config.columns)
        : config.columns || _default.columns;

      config.settings = typeof config.settings === 'string'
        ? JSON.parse(config.settings)
        : config.settings || _default.settings;

      config.settings.overdue = checkPricingAccess('overdue_tasks') ? config.settings.overdue : false;

      state.currentConfig = config;

      this.commit('headerView/assignViewSettings', config.settings.viewSettings);
      this.commit('headerView/setOverdueTasks', config.settings.overdue);
    },

    updateConfigColumns(state, columns) {
      state.unsavedChangesInConfig = state.unsavedChangesInConfig
        || !_.isEqual(columns, state.currentConfig.columns);

      state.currentConfig.columns = columns;
    },

    updateViewSettings(state) {
      if (!state.currentConfig) return;

      const settings = {
        viewSettings: {
          skins: this.getters['headerView/viewSettings'].skins,
          completedTask: this.getters['headerView/viewSettings'].completedTask,
        },
      };

      const overdue = this.getters['headerView/isOverdueTasks'];

      if (overdue) settings.overdue = overdue;

      state.unsavedChangesInConfig = state.unsavedChangesInConfig || !_.isEqual(settings, state.currentConfig.settings);
      state.currentConfig.settings = settings;
    },

    setUnsavedChangesInConfig(state, flag) {
      state.unsavedChangesInConfig = flag;
    },

    updateTask(state, taskData) {
      const taskIndex = state.totalTasks.findIndex(t => t.id === taskData.id);
      const filteredTaskIndex = state.filtredTasks.findIndex(t => t.id === taskData.id);

      if (taskIndex > -1) {
        state.totalTasks.splice(taskIndex, 1, taskData);
      }
      if (filteredTaskIndex > -1) {
        state.filtredTasks.splice(filteredTaskIndex, 1, taskData);
      }
    },

    deleteTasks(state, { taskIds, projectIds }) {
      if (Array.isArray(projectIds) && projectIds.length) {
        excludeItems(state.filtredTasks, 'gantt_id', projectIds);
        excludeItems(state.totalTasks, 'gantt_id', projectIds);
      }

      if (Array.isArray(taskIds) && taskIds.length) {
        excludeItems(state.filtredTasks, 'id', taskIds);
        excludeItems(state.totalTasks, 'id', taskIds);
      }

      this.commit('headerView/setListTasksCount', state.filtredTasks.length || 0);

      function excludeItems(arr, property, vals) {
        const indexes = [];

        arr.forEach((item, index) => {
          if (vals.includes(item[property])) {
            indexes.push(index);
          }
        });

        indexes.reverse().forEach(index => {
          arr.splice(index, 1);
        });
      }
    },
  },

  actions: {
    destroy({ commit }) {
      commit('setCurrentConfig', null);
      commit('setTasks', null);
      commit('setFiltredTasks', null);
    },

    async defineCurrentConfig({ getters, commit }) {
      commit('setLoading', true);

      if (!getters.configs) {
        const condition = { user_id: user.id };
        const configs = await axios.get(getters.url, condition);

        commit('setConfigs', configs.data);
      }

      const multiview_id = multiViewsProjectsModel.getActiveGanttId() ? multiViewsProjectsModel.getActiveGanttId().id : null;
      const project_id = +routerHelper.getCurrentRoute().params.projectId || null;
      let currentConfig = _.find(getters.configs, { project_id, multiview_id }) || null;

      if (!currentConfig) {
        const defaultConf = {
          multiview_id,
          project_id,
          columns: JSON.stringify(_default.columns),
          settings: JSON.stringify(_default.settings),
        };

        const res = await axios.post(getters.url, defaultConf);

        commit('setConfigs', res.data);
        currentConfig = _.find(getters.configs, { project_id, multiview_id }) || null;
      }

      commit('setCurrentConfig', currentConfig);
      commit('setLoading', false);
    },

    saveColumnsConfig({ getters, commit, dispatch }, columnsConfig) {
      if (!getters.currentConfig || !columnsConfig) return;
      const isEqual = _.isEqual(columnsConfig, getters.currentConfig.columns);

      if (isEqual) return;

      commit('updateConfigColumns', columnsConfig);
      dispatch('saveConfig');
    },

    async saveConfig({ getters, commit }) {
      commit('updateViewSettings');
      if (!getters.unsavedChangesInConfig) return;

      const config = { ...getters.currentConfig };

      config.settings = JSON.stringify({ ...getters.currentConfig.settings });
      config.columns = JSON.stringify({ ...getters.currentConfig.columns });
      commit('setUnsavedChangesInConfig', false);

      const res = await axios.put(`${getters.url}/${config.id}`, config);

      commit('setConfigs', res.data);
    },
  },
};

export default listViewStore;
